export const SET_LOADING = 'src/store/activityList/SET_LOADING'
export const SET_ACTIVITIES = 'src/store/activityList/SET_ACTIVITIES'
